import React from 'react'
import TableCellCheckbox from './TableCellCheckbox'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Select
} from '../../../Functions/Table'
import {
  SELECTED_NOTIFICATIONS
} from '../../../Redux/Actions/Notifications'

const TableCellCheckboxNotifications = ({ item }) => {
  const dispatch = useDispatch()
  const selected = useSelector(state => state.notifications.selected)
  return (
    <TableCellCheckbox
      checked={selected.includes(item.id)}
      onClick={() => Select(dispatch, SELECTED_NOTIFICATIONS, selected, item.id)}
    />
  )
}

export default TableCellCheckboxNotifications
